import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
import { addToast } from "./toastService";
import i18n from "../Services/i18n";

class AccountService {
  static CreateUserAccount(userAccount) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/create`, userAccount)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          const status = error.response.status;
          const data = error.response.data;

          if (status === 400) {
            if (data.code === "EmailAlreadyExists") {
              addToast(
                i18n.t("RegisterForm.Error.EmailAlreadyExists"),
                "EmailAlreadyExists",
                "ERROR",
                true,
              );
              return null;
            }

            throw new Error(`Bad Request: ${data.message || "Invalid input"}`);
          } else {
            throw new Error(`Erreur ${status}: ${data.message || "Une erreur est survenue"}`);
          }
        } else if (error.request) {
          addToast(
            i18n.t("Generic.ToastMessage.ServerNotResponding"),
            "ServerNotResponding",
            "ERROR",
            true,
          );
          throw new Error("Aucune réponse du serveur.");
        } else {
          console.log("Erreur Axios:", error.message);
          throw new Error("Erreur de configuration de la requête.");
        }
      });
  }

  static Logout() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/auth/logout`, config)
      .then((response) => {
        if (response.status < 299) {
        }
        return response.status;
      })
      .catch((error) => {
        throw error;
      });
  }

  static GetPrivileges() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/account/privileges/`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static ChangeEmail(oldEmail, newEmail) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/changeemail`, { oldEmail, newEmail }, config)
      .then((response) => {
        if (response.status < 299 && response.data.data === true) {
          if (response.data.code === "succeed") {
            addToast(
              i18n.t("MyAccount.ChangeEmail.Sent"),
              "changemailrequestSuccess",
              "SUCCESS",
              false,
            );
          } else {
            addToast(
              i18n.t("MyAccount.ChangeEmail.Invalid"),
              "changemailrequestInvalid",
              "ERROR",
              true,
            );
          }
        } else if (response.data.code === "TooManyChangeRequest") {
          addToast(
            i18n.t("MyAccount.ChangeEmail.TooManyRequest"),
            "changemailrequestTooManyReq",
            "ERROR",
            true,
          );
        } else {
          addToast(i18n.t("MyAccount.ChangeEmail.Invalid"), "changemailrequest", "ERROR", true);
        }
        return response.status;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
      });
  }

  static ChangePasswordFromRequest(x, y, z, password) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/resetpassword`, {
        x,
        y,
        z,
        password,
      })
      .then((response) => {
        if (response.status < 299) {
          if (response.data.data === true) {
            localStorage.removeItem("token");
            window.location.href = "/login?changed";
          } else {
            if (response.data.code === "invalidpassword") {
              addToast(i18n.t("ChangePassword.NewPwdInvalid"), "changepasswordfail", "ERROR", true);
              return false;
            } else {
              addToast(
                i18n.t("ChangePassword.RequestNewPasswordFailed"),
                "changepasswordfail",
                "ERROR",
                true,
              );
              return false;
            }
          }
        } else {
          addToast(i18n.t("ChangePassword.Invalid"), "changemailrequest", "ERROR", true);
        }
        return false;
      })
      .catch((error) => {
        console.log(error);
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static ChangePassword(oldPassword, newPassword) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(
        `${envConfig.apiBaseUrl}/api/account/changepassword`,
        { oldPassword, newPassword },
        config,
      )
      .then((response) => {
        if (response.status < 299) {
          if (response.data.data === true) {
            localStorage.removeItem("token");
            window.location.href = "/login?changed";
          } else {
            if (response.data.code === "invalidoldpwd") {
              addToast(i18n.t("ChangePassword.OldPwdInvalid"), "changepasswordfail", "ERROR", true);
              return false;
            } else if (response.data.code === "invalidnewpwd") {
              addToast(i18n.t("ChangePassword.NewPwdInvalid"), "changepasswordfail", "ERROR", true);
              return false;
            }
          }
        } else {
          addToast(i18n.t("ChangePassword.Invalid"), "changemailrequest", "ERROR", true);
        }
        return false;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static RequestChangePassword(email) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/requestchangepassword`, {
        email,
      })
      .then((response) => {
        if (response.status < 299) {
          if (response.data.data === true) {
            addToast(
              i18n.t("ChangePassword.RequestNewPasswordSucceed"),
              "changepasswordrequestsucceed",
              "SUCCESS",
              false,
            );
            return true;
          } else {
            if (response.data.code === "failed") {
              addToast(
                i18n.t("ChangePassword.RequestNewPasswordFailed"),
                "changepasswordrequestfail",
                "ERROR",
                true,
              );
              return false;
            } else if (response.data.code === "activetoken") {
              addToast(
                i18n.t("ChangePassword.RequestNewPasswordActiveToken"),
                "changepasswordrequestfail",
                "ERROR",
                true,
              );
              return false;
            }
          }
        }
      })
      .catch((error) => {
        addToast(
          i18n.t("ChangePassword.RequestNewPasswordFailed"),
          "changepasswordrequestfail",
          "ERROR",
          true,
        );
        return false;
      });
  }

  static ConfirmChangeEmail(clientExternalId, token) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/confirmchangeemail/${clientExternalId}/${token}`)
      .then((response) => {
        if (response.status < 299) {
          return response.data.code;
        } else {
          return "failed";
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static ConfirmAccount(clientExternalId, token) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/confirm/${clientExternalId}/${token}`)
      .then((response) => {
        if (response.status < 299) {
          return response.data.code;
        } else {
          return "failed";
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static CancelChangeEmail(clientExternalId, token) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/cancelchangeemail/${clientExternalId}/${token}`)
      .then((response) => {
        if (response.status < 299) {
          return response.data.code;
        } else {
          return "failed";
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
      });
  }

  static KeepAlive() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/auth/keepalive`, {}, config)
      .then((response) => {
        if (response.status < 299) {
        }
        return response.status;
      })
      .catch((error) => {
        throw error;
      });
  }

  static Login(username, password, rememberMe, saveTokenCallback) {
    return axios
      .post(`${envConfig.apiBaseUrl}/api/auth/login`, {
        username,
        password,
        rememberMe,
      })
      .then((response) => {
        if (response.status < 299) {
          if (saveTokenCallback) {
            saveTokenCallback(response.data.token, new Date(response.data.expireOn), rememberMe);
          } else {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("expireOn", new Date(response.data.expireOn));
            localStorage.setItem("rememberMe", rememberMe);
          }
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }

  static IsLoggedIn() {
    const token = localStorage.getItem("token");
    const expireOn = localStorage.getItem("expireOn");

    if (!token || !expireOn) {
      return false;
    }

    const expireDate = new Date(expireOn);

    if (expireDate < new Date()) {
      return false;
    }

    return true;
  }

  static CancelSubscription() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/cancelsubscription`, {}, config)
      .then((response) => {
        if (response.status < 299) {
          return response.data.code;
        } else {
          return "failed";
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static UpgradeSubscription() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/upgradesubscription`, {}, config)
      .then((response) => {
        if (response.status < 299) {
          return response.data.code;
        } else {
          return "failed";
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? "failed" : "failed";
      });
  }

  static ResumeSubscription() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .post(`${envConfig.apiBaseUrl}/api/account/resumesubscription`, {}, config)
      .then((response) => {
        if (response.status < 299) {
          if (response.data.code === "TOOMANYRESUME") {
            addToast(
              i18n.t("MyAccount.Subscription.TooManyResume"),
              "TOOMANYRESUME",
              "ERROR",
              true,
            );
          } else {
            addToast(i18n.t("MyAccount.Subscription.ResumeInfo"), "SUBRESUME", "SUCCESS", true);
            return true;
          }
        } else {
          return false;
        }
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        return ok ? true : false;
      });
  }
}
export default AccountService;
